import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-consent-list',
  templateUrl: './consent-list.component.html',
  styleUrls: ['./consent-list.component.scss']
})
/**
 * This component is being used in the consent history component
 */
export class ConsentListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
